<nav aria-label="Breadcrumb">
    <ol class="breadcrumb-list d-flex flex-wrap align-items-center m-0 p-0">
        <li *ngFor="let item of breadcrumbItems" class="breadcrumb-item d-inline-block" [class.active]="!item.route">
            <a *ngIf="item.route" [routerLink]="item.route">{{item.name}}</a>
            <span *ngIf="!item.route" class="current" aria-current="page">{{item.name}}</span>
        </li>
    </ol>
</nav>
